import {ItemDto} from '../../../../models/Items/IItem';
import {IRecipe} from '../../../../models/Recipe/IRecipe';
import {IRecipeLight} from '../../../../models/Recipe/IRecipeLight';
import {GuidLightDto} from '../../../../models/common/IGuidLight';
import RecipeForm from '../../shared/RecipeForm';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

interface Props { recipes?: IRecipeLight[]; items?: ItemDto[]; fillings?: GuidLightDto[]; productTypes?: GuidLightDto[]; onSubmit: (value: IRecipe) => Promise<void>; }
export default function CreateRecipe({items, fillings, productTypes, onSubmit}: Props) {
    const {t} = useAppTranslation();
    return <RecipeForm items={items} fillings={fillings} productTypes={productTypes} onSubmit={onSubmit} submitLabel={t('recipes:save_recipe')}/>;
}
